// Test VPS (admin.test.cinemapp.com) - built by .github/workflows/deploy-test.yml with --configuration=test
export const environment = {

	production: true,
	beta: false,

	websiteRoot: 'https://test.cinemapp.be/',

	api: 'https://api.test.cinemapp.com/',
	cdn: 'https://d2tm7dw2itqh3w.cloudfront.net/', // cinemapp-platform-test + fallback to the production bucket

    filmwebApi: 'https://api.filmweb.cinemapp.pro/'

};
